import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerHeader,
  DrawerOverlay,
  Button,
  Input,
  Select,
  useToast,
  VStack,
  HStack,
} from '@chakra-ui/react';
import AdminDrawerContent from '../layout/AdminDrawerContent';
import { AdminField, useAdminFormFieldProps } from '../layout/AdminFormControls';

const ModelsEditModal = ({ isOpen, onClose, model, isNew, onCreate, onUpdate, brands }) => {
  const [formData, setFormData] = React.useState({});
  const toast = useToast();
  const { fieldProps, selectProps } = useAdminFormFieldProps();

  React.useEffect(() => {
    setFormData({
      id: model?.id || null,
      description: model?.description || '',
      brandId: model?.brandId || model?.brand?.id || '',
      enabled: model?.enabled ?? true,
    });
  }, [model, isNew]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = () => {
    try {
      if (!formData.description || !formData.brandId) {
        toast({
          title: 'Campos requeridos',
          description: 'Por favor complete todos los campos obligatorios.',
          status: 'warning',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      if (isNew) {
        onCreate(formData);
        toast({
          title: 'Modelo creado',
          description: 'El nuevo modelo se ha guardado exitosamente.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        onUpdate(formData);
        toast({
          title: 'Modelo actualizado',
          description: 'Los cambios se han guardado exitosamente.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }
      onClose();
    } catch (error) {
      toast({
        title: 'Error al guardar modelo',
        description: error.message || 'No se pudo completar la operación.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} closeOnOverlayClick={false}>
      <DrawerOverlay />
      <AdminDrawerContent>
        <DrawerCloseButton />
        <DrawerHeader fontSize="lg" fontWeight="bold">
          {isNew ? 'Nuevo modelo' : 'Editar modelo'}
        </DrawerHeader>
        <DrawerBody>
          <VStack spacing={3} align="stretch">
            <AdminField label="Descripción" isRequired>
              <Input
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Descripción del modelo"
                {...fieldProps}
              />
            </AdminField>
            <AdminField label="Marca" isRequired>
              <Select
                name="brandId"
                value={formData.brandId}
                onChange={handleChange}
                placeholder="Seleccionar marca"
                {...selectProps}
              >
                {brands?.map((brand) => (
                  <option key={brand.id} value={brand.id}>
                    {brand.name}
                  </option>
                ))}
              </Select>
            </AdminField>
          </VStack>
        </DrawerBody>
        <HStack justify="flex-end" p={4} borderTopWidth="1px" borderColor="gray.100">
          <Button size="sm" variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button size="sm" variant="adminPrimary" onClick={handleSave}>
            Guardar
          </Button>
        </HStack>
      </AdminDrawerContent>
    </Drawer>
  );
};

export default ModelsEditModal;
